import { lazy } from "react"

const CurrentPairsPage$$__react__lazy__component = lazy(() => 
    import("./CurrentPairsPage__original__module.mjs")
        .then(module => module.get_$$CurrentPairsPage$$CurrentPairsPage$$react__component$$3nm6i0upx8r52())
        .then(component => ({ default: component }))
)

export const get_$$CurrentPairsPage$$CurrentPairsPage$$react__component$$3nm6i0upx8r52 = () => CurrentPairsPage$$__react__lazy__component